import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'

class CreateBloc {

    createChannel = new Subject()
    trainingListChannel = new Subject()
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({ status: apiResponse.INITIAL })
        this.trainingListChannel.next({ status: apiResponse.INITIAL })
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.createChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchTrainingList = async (query) => {
        try {
            this.trainingListChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchTrainingList(query).then((result) => {
                this.trainingListChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.trainingListChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

}

export default CreateBloc